export const GET_USER_MENU = "GET_USER_MENU"
export const GET_USER_MENU_SUCCESS = "GET_USER_MENU_SUCCESS"
export const GET_USER_MENU_FAIL = "GET_USER_MENU_FAIL"
